import { create } from 'zustand';

// https://zustand.docs.pmnd.rs/guides/updating-state
type State = {
    finalCanvasBase64: string;
    originalCanvasBase64: string;
};

type Action = {
    setFinalCanvasBase64: (firstName: State['finalCanvasBase64']) => void;
    setOriginalCanvasBase64: (lastName: State['originalCanvasBase64']) => void;
};

export const useImageEditorInfoStore = create<State & Action>((set) => ({
    finalCanvasBase64: '',
    originalCanvasBase64: '',
    setFinalCanvasBase64: (finalCanvasBase64) =>
        set((state) => ({ finalCanvasBase64: finalCanvasBase64 })),
    setOriginalCanvasBase64: (originalCanvasBase64) =>
        set((state) => ({ originalCanvasBase64: originalCanvasBase64 })),
}));
